export default __webpack_public_path__ + "static/media/036-retirement.976f9b87.svg";